import { render } from "./productChart1.vue?vue&type=template&id=47405140"
import script from "./productChart1.vue?vue&type=script&lang=js"
export * from "./productChart1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__